import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PcSubmenuList = _resolveComponent("PcSubmenuList")!
  const _component_pg_icon = _resolveComponent("pg-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_aside = _resolveComponent("el-aside")!

  return (_openBlock(), _createBlock(_component_el_aside, {
    class: "pe-layout-aside",
    width: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_menu, {
        class: "pe-menu",
        mode: "vertical",
        "default-active": _ctx.state.activeIndex,
        collapse: _ctx.state.isCollapse,
        "unique-opened": "",
        onOpen: _ctx.handleMenuOpen
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuListFiltered, (menu, i) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (menu.children && menu.children.length)
                ? (_openBlock(), _createBlock(_component_PcSubmenuList, {
                    key: i,
                    data: menu,
                    index: i.toString()
                  }, null, 8, ["data", "index"]))
                : (menu.link)
                  ? (_openBlock(), _createBlock(_component_el_menu_item, {
                      key: `${i}-${menu.name}`,
                      index: menu.link,
                      onClick: ($event: any) => (_ctx.jumpMenu(menu.link))
                    }, {
                      title: _withCtx(() => [
                        _createElementVNode("span", {
                          title: menu.nameShow || menu.name,
                          class: _normalizeClass([
                menu.children && menu.children.length
                  ? 'pe-menu-collape-btn-span'
                  : 'pe-menu-collape-btn-span-no'
              ])
                        }, _toDisplayString(menu.nameShow || menu.name), 11, _hoisted_1)
                      ]),
                      default: _withCtx(() => [
                        (menu.icon)
                          ? (_openBlock(), _createBlock(_component_pg_icon, {
                              key: 0,
                              class: "menu-icon",
                              name: menu.icon
                            }, null, 8, ["name"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["index", "onClick"]))
                  : _createCommentVNode("", true)
            ], 64))
          }), 256)),
          _createElementVNode("div", {
            class: "pe-menu-collape-btn",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args))),
            onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
          }, [
            (_ctx.state.isCollapse)
              ? (_openBlock(), _createBlock(_component_pg_icon, {
                  key: 0,
                  name: "right-2",
                  size: "20",
                  style: {"vertical-align":"middle","margin-top":"-3px"}
                }))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_pg_icon, {
                    name: "left-2",
                    size: "20",
                    style: {"vertical-align":"middle","margin-top":"-3px"}
                  }),
                  _createElementVNode("span", null, _toDisplayString(_ctx.t('packUp')), 1)
                ], 64))
          ], 32)
        ]),
        _: 1
      }, 8, ["default-active", "collapse", "onOpen"])
    ]),
    _: 1
  }))
}